import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filenameFromString } from '@epicuro-next/utilities';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BlobEntity } from './zip.service';

export interface FilesMetadata {
  url: string;
  filename?: string;
}

/**
 * Service for File related operations
 */
@Injectable()
export class FileService {
  /**
   * Http client is used to download the files
   * @param http
   */
  constructor(private http: HttpClient) {}

  /**
   * Given a url returns an Observable with the correspondent Blob
   */
  public getFileFromUrl(
    url: string,
    filename?: string,
  ): Observable<BlobEntity> {
    /* Last non-empty string from pathname */
    const defaultFileName = new URL(url).pathname
      .split('/')
      .filter(Boolean)
      .reverse()[0];

    return this.http
      .get(url, {
        responseType: 'blob',
      })
      .pipe(
        map((blob) => ({ blob, filename: filename || defaultFileName })),
        catchError(() => of({ filename: filename || defaultFileName })),
      );
  }

  /**
   * Given a blob, saves it with the specified fileName.
   * @param blob
   * @param fileName
   */
  public saveBlob(blob: Blob, fileName: string) {
    if (!blob.size) {
      return;
    }
    const downloadLink = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);
    downloadLink.href = blobUrl;
    downloadLink.download = filenameFromString(fileName);
    downloadLink.click();
    URL.revokeObjectURL(blobUrl);
  }

  public getFilesFromUrl(data: FilesMetadata[]): Observable<BlobEntity[]> {
    return combineLatest(
      data.map(({ filename, url }) => this.getFileFromUrl(url, filename)),
    );
  }
}
